import React from "react";

import * as S from "../styles";

const IdentificationSectionLoading: React.FC = () => (
  <S.SectionCard aria-busy="true" aria-live="polite">
    <S.SectionHeader>
      <S.StepBadge active>1</S.StepBadge>
      <h2>Identificação</h2>
    </S.SectionHeader>
    <S.IdentificationLoadingBody>
      <S.CepSpinner aria-hidden="true" />
      <span className="hint">Carregando...</span>
    </S.IdentificationLoadingBody>
  </S.SectionCard>
);

export default IdentificationSectionLoading;
